var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnblock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.7888,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5C10.0685 5 8.5 6.5685 8.5 8.5C8.5 10.4315 10.0685 12 12 12C13.9315 12 15.5 10.4315 15.5 8.5C15.5 6.5685 13.9315 5 12 5ZM12 6C13.38 6 14.5 7.12 14.5 8.5C14.5 9.88 13.38 11 12 11C10.62 11 9.5 9.88 9.5 8.5C9.5 7.12 10.62 6 12 6Z",
    fill: "#2DA771"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 18H12C12.276 18 12.5 18.224 12.5 18.5C12.5 18.776 12.276 19 12 19H5.5C5.224 19 5 18.776 5 18.5C5 18.5 5 18.0875 5 17.5C5 15.0145 7.0145 13 9.5 13H12C12.276 13 12.5 13.224 12.5 13.5C12.5 13.776 12.276 14 12 14H9.5C7.567 14 6 15.567 6 17.5V18Z",
    fill: "#2DA771"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2505 13C14.457 13 13.001 14.456 13.001 16.2495C13.001 18.043 14.457 19.499 16.2505 19.499C18.044 19.499 19.5 18.043 19.5 16.2495C19.5 14.456 18.044 13 16.2505 13ZM16.2505 14C17.492 14 18.5 15.008 18.5 16.2495C18.5 17.491 17.492 18.499 16.2505 18.499C15.009 18.499 14.001 17.491 14.001 16.2495C14.001 15.008 15.009 14 16.2505 14Z",
    fill: "#2DA771"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0425 16.282L17.142 15.1515C17.3345 14.9535 17.6515 14.949 17.849 15.1415C18.047 15.334 18.0515 15.6505 17.859 15.8485L16.401 17.3475C16.307 17.4445 16.1775 17.499 16.0425 17.499C15.9075 17.499 15.7785 17.4445 15.684 17.3475L14.642 16.276C14.4495 16.078 14.454 15.7615 14.652 15.569C14.85 15.3765 15.1665 15.381 15.359 15.579L16.0425 16.282Z",
    fill: "#2DA771"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnblock);
export default __webpack_public_path__ + "static/media/unblock.9e144fd1792581866eb948c7811c17f9.svg";
export { ForwardRef as ReactComponent };